<script>

    export default {

        data: function () {
            return {
                waiting_list_entry: null,
                info: null,
                can_use_analytics: false,
                permalink: permalink
            }
        },

        mounted: function () {

            this.$event_bus.$on('LoadData', (data) => {
                this.can_use_analytics = data.can_use_analytics;
            });


            this.$event_bus.$on('finish', (data) => {
                this.waiting_list_entry = data.data.waiting_list_entry;
                this.info = data.data;

                if (!this.waiting_list_entry) {
                    return;
                }

                if(this.can_use_analytics && conversion_pixel_id && conversion_pixel_label && typeof gtag === 'function'){
                    gtag('event', 'conversion', {'send_to': 'AW-'+conversion_pixel_id+'/'+conversion_pixel_label});
                }

                if(data.data.facebook_pixel_id && data.data.facebook_conversion_event_code && typeof fbq === 'function'){
                    fbq('track', data.data.facebook_conversion_event_code, { value: 0, currency: Config.get('countries.'+locale+'.currency') });
                }
            });
        },

        beforeUnmount() {
            this.$event_bus.$off('LoadData');
            this.$event_bus.$off('finish');
        },

        computed: {
            preferred_date() {

                if (!this.waiting_list_entry || !this.waiting_list_entry.preferred_time){
                    return null;
                }

                return moment(this.waiting_list_entry.preferred_time).locale(moment_locale).format('D MMMM YYYY');
            },

            preferred_time() {

                if (!this.waiting_list_entry || !this.waiting_list_entry.preferred_time){
                    return null;
                }

                return `${this.waiting_list_entry.time} - ${this.waiting_list_entry.endTime}`;
            }
        },

        methods: {
            restart() {
                location.reload();
            }
        },
    };


</script>


<template>

    <div class="panel m-b-15 waiting-list-success-panel" v-if="waiting_list_entry" id="booking-success-2-panel">
        <div class="panel-body row" id="booking-success-2-booking">

            <div class="col-xs-12 col-sm-8 text-center waiting-list-success">
                <i class="zmdi zmdi-check-circle booking-success-icon"></i>
                <h3 class="m-b-30">
                    {{ trans('waiting_list.subscription_confirmed') }}
                </h3>
                <ep-banner>
                    <strong>{{ trans('online_booking.waiting_list_not_confirmation') }}</strong><br />
                    <span>{{ trans('waiting_list.email.confirmation_info_2') }}</span>
                </ep-banner>
            </div>

            <div class="col-xs-12 col-sm-4 waiting-list-info">
                <div v-if="preferred_date" class="text-left">
                    <span>{{ trans('global.date') }}</span>
                    <h5 class="m-t-0">{{ preferred_date }}</h5>
                </div>

                <div class="text-left" v-if="preferred_time && waiting_list_entry.time != '0:00'">
                    <span>{{ trans('waiting_list.preferred_time') }}</span>
                    <h5 class="m-t-0">{{ preferred_time }}</h5>
                </div>

                <div class="text-left">
                    <span v-if="waiting_list_entry.entry_products && waiting_list_entry.entry_products.length == 1">{{ trans('global.product') }}</span>
                    <span v-if="waiting_list_entry.entry_products && waiting_list_entry.entry_products.length > 1">{{ trans('global.products') }}</span>
                    <h5 class="m-t-0" v-for="(entryProduct, index) in waiting_list_entry.entry_products" :key="index">
                        {{ entryProduct.product.name }}
                        <span v-if="entryProduct.addons && entryProduct.addons.length">(+ {{ entryProduct.addons.map(entryAddon => entryAddon.addon.name).join(', ') }})</span>
                    </h5>
                </div>
            </div>

        </div>
    </div>

</template>
